import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './SubstitutionEditScreen';
import SubstitutionEdit from './SubstitutionEditScreen';
import { StoreState } from 'src/store/reducers';
import {
    getSubstitution,
    deleteFileSubstitution,
    getFiles,
    asyncCreateFilesSubstitution,
} from 'src/store/actions/substitution-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        substitution: state.substitutions.current,
        files: state.substitutions.currentFiles,
        inProgress: state.substitutions.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getSubstitution(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: async (id, files) => await asyncCreateFilesSubstitution(id, files, dispatch),
        removeFile: (id) => dispatch(deleteFileSubstitution(id)),
    };
}

const SubstitutionEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SubstitutionEdit);

export default SubstitutionEditScreen;
